<script setup>
import { computed } from "vue";
import { useScene } from "../composables/useScene";
import { useGlobalStore } from "@stores/global";

const { canvasRef } = useScene();
const globalStore = useGlobalStore();

const isVote = computed(() => globalStore.activePage === "vote");
</script>

<template>
    <div
        class="globe-canvas"
        :class="{
            'globe-canvas--vote': isVote,
        }"
    >
        <canvas ref="canvasRef"></canvas>
    </div>
</template>

<style scoped>
.globe-canvas {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    transition: transform 1.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.globe-canvas canvas {
    width: 100%;
    height: 100%;
}

@media (min-width: 1024px) {
    .globe-canvas--vote {
        transform: translateX(-10%);
    }
}
</style>
